import { COUNTRY_CONFIG } from "../config/countries";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { STRINGS } from "@/i18n";

export function AboutPage() {
  return (
    <Card>
      <CardHeader>
        <h2 className="text-2xl font-semibold leading-none tracking-tight">
          {STRINGS.about.title}
        </h2>
      </CardHeader>
      <CardContent className="space-y-4 leading-relaxed text-foreground">
        <p>{STRINGS.about.intro(COUNTRY_CONFIG.domain)}</p>
        <p>
          {STRINGS.about.sourcePrefix}{" "}
          <a
            href="https://transparency.entsoe.eu/"
            className="text-primary underline underline-offset-2 hover:no-underline"
            target="_blank"
            rel="noreferrer"
          >
            https://transparency.entsoe.eu/
          </a>
          .
        </p>
        <p>
          {STRINGS.about.contact}{" "}
          <a
            href={`mailto:${COUNTRY_CONFIG.contactEmail}`}
            className="text-primary underline underline-offset-2 hover:no-underline"
          >
            {COUNTRY_CONFIG.contactEmail}
          </a>
        </p>
      </CardContent>
    </Card>
  );
}
